// ⬇️ adicione os hooks
import React, { useEffect, useRef } from "react";

import { Parallax } from './Parallax'
import { Sign } from './Sign'
import * as S from './style'

export const HowItWorks = () => {
  // ⬇️ ref para o box que já tem overflow-y
  const innerScrollRef = useRef(null);

  // ⬇️ handoff: quando o scroll interno acaba, empurra pro window
  useEffect(() => {
    const el = innerScrollRef.current;
    if (!el) return;

    let startY = 0;
    const EPS = 2; // tolerância p/ arredondamentos

    const atTop = () => el.scrollTop <= EPS;
    const atBottom = () =>
      el.scrollTop + el.clientHeight >= el.scrollHeight - EPS;

    const onWheel = (e) => {
      const d = e.deltaY;
      if ((d < 0 && atTop()) || (d > 0 && atBottom())) {
        e.preventDefault(); // precisa ser passive:false
        window.scrollBy({ top: d, left: 0, behavior: "auto" });
      }
    };

    const onTouchStart = (e) => {
      startY = e.touches[0].clientY;
    };

    const onTouchMove = (e) => {
      const y = e.touches[0].clientY;
      const dy = y - startY; // >0 dedo desce (scroll sobe)
      if ((dy > 0 && atTop()) || (dy < 0 && atBottom())) {
        e.preventDefault(); // precisa ser passive:false
        window.scrollBy({ top: -dy, left: 0, behavior: "auto" });
      }
      startY = y; // mantém o gesto contínuo
    };

    el.addEventListener("wheel", onWheel, { passive: false });
    el.addEventListener("touchstart", onTouchStart, { passive: true });
    el.addEventListener("touchmove", onTouchMove, { passive: false });

    return () => {
      el.removeEventListener("wheel", onWheel);
      el.removeEventListener("touchstart", onTouchStart);
      el.removeEventListener("touchmove", onTouchMove);
    };
  }, []);

  return (
    <S.Content>
      <Sign />
      <S.Wrapper id='howItWorks'>
        <S.TextBox>
          <S.Title>
            Do sinal ao relatório. <br />Tudo conectado, tudo sob controle
          </S.Title>
          <S.Text>
            O WisePrevent transforma dados invisíveis em decisões inteligentes.<br />
            Cada risco detectado vira uma ação programada, uma equipe orientada e um relatório completo.<br />
            Sem ruídos, sem improvisos, sem adivinhação.
          </S.Text>
        </S.TextBox>
      </S.Wrapper>

      <S.WrapperParallaxBox>
        <S.ParallaxBox ref={innerScrollRef}>
          <div className="luminosity" />
          <Parallax />
        </S.ParallaxBox>

        <S.ParallaxMobileBox >
          <div className="luminosity" />
          <Parallax />
        </S.ParallaxMobileBox>
      </S.WrapperParallaxBox>
    </S.Content>
  )
}
